import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type PartnerSelfSignupInfoFragment = { __typename?: 'PartnerSelfSignup', id: string, created_at?: string | null, panda_doc_id?: string | null, signed_at?: string | null, company_name?: string | null, company_type?: string | null, email?: string | null, phone?: string | null, package?: string | null, first_name?: string | null, last_name?: string | null, wanted_container_ids?: Array<number | null> | null, iban?: string | null, iban_name?: string | null, bic?: string | null, vat?: string | null, how_did_you_know_about_vytal?: string | null, address?: { __typename?: 'PartnerSelfSignupAddress', street?: string | null, zipcode?: string | null, city?: string | null, country?: string | null } | null, billing_address?: { __typename?: 'PartnerSelfSignupAddress', street?: string | null, zipcode?: string | null, city?: string | null, country?: string | null } | null };

export const PartnerSelfSignupInfoFragmentDoc = gql`
    fragment PartnerSelfSignupInfo on PartnerSelfSignup {
  id
  created_at
  panda_doc_id
  id
  created_at
  signed_at
  panda_doc_id
  company_name
  company_type
  email
  phone
  package
  first_name
  last_name
  address {
    street
    zipcode
    city
    country
  }
  billing_address {
    street
    zipcode
    city
    country
  }
  wanted_container_ids
  iban
  iban_name
  bic
  vat
  how_did_you_know_about_vytal
}
    `;